import { tooltipClasses } from '@zenbusiness/zui/Tooltip';

export const WrapperStyle = ({ theme }) => ({
  width: '100%',

  gridColumn: '1 / span 4',

  [theme.breakpoints.up('sm')]: {
    gridColumn: '2 / span 4'
  },

  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / span 6'
  },

  [theme.breakpoints.up('lg')]: {
    gridColumn: '4 / span 6'
  }
});

export const StepNumberStyle = () => ({
  minWidth: '40px',
  height: '40px',
  borderRadius: '50%',
  backgroundColor: '#000'
});

export const LinkStyles = () => ({
  cursor: 'pointer',
  textDecoration: 'underline'
});
export const StepItemStyle = ({ theme }) => ({
  '&.MuiButtonBase-root': {
    padding: '8px 0px',
    [theme.breakpoints.up('md')]: {
      padding: '8px 0px',
      ...theme.typography.md
    },
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
});

export const LinkButtonStyle = () => ({
  marginTop: '16px',
  paddingLeft: '9px!important',
  '& .MuiButton-startIcon': {
    marginRight: '9px'
  },
  '&.Mui-disabled': {
    border: 'none'
  }
});

export const TooltipStyle = ({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    ...theme.typography.xs,
    height: '32px',
    padding: '8px 14px',
    borderRadius: '12px',
    backgroundColor: theme.palette.fixed.black
  }
});

export const DialogContentStyle = ({ theme }) => ({
  paddingTop: '40px',
  backgroundColor: theme.palette.background.grey.main,
  [theme.breakpoints.up('md')]: {
    paddingTop: '80px'
  }
});
